import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-naps-file-picker',
  imports: [NgbTooltipModule],
  templateUrl: './naps-file-picker.component.html',
  styleUrl: './naps-file-picker.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NapsFilePickerComponent),
      multi: true,
    },
  ],
})
export class NapsFilePickerComponent implements ControlValueAccessor {
  @Input() label: string = 'Upload File';
  @Input() rightLabel:string|undefined = undefined;
  @Input() isRequired:boolean = false;
  @Input() accept: string = '.jpeg,.jpg,.png,.pdf';
  @Input() note: string = 'Please upload only (jpeg, jpg, png, pdf) files. Maximum 4MB only allowed.';
  @Input() fileName: string = '';
  @Input() tooltipText: string = ''
  @Output() fileSelected = new EventEmitter<Event>();
  @Output() rightButtonClicked = new EventEmitter<string>();
  @Input() isDisabled = false;
  @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;

  selectedFileName: string = '';
  file: File | null = null;

  onChange = (file: File | null) => {};
  onTouched = () => {};

  writeValue(file: File | null): void {
    this.file = file;
    this.selectedFileName = file ? file.name : '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  triggerFileInput() {
    this.fileInputRef.nativeElement.click();
  }

  onFileChosen(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.file = file;
      this.selectedFileName = file.name;
      this.onChange(file);
      this.fileSelected.emit(event);
    }
  }

  clearFile() {
    this.file = null;
    this.selectedFileName = '';
    this.onChange(null);
    this.fileInputRef.nativeElement.value = '';
  }

}
